
import * as L from 'leaflet'
import {Layer, RESOURCE_AUTH_TOKEN_PARAMETER} from "@/engine/layers/layer.js";
import {shortLivedTokenManager} from "@/context/global.js";

export class RasterLayer extends Layer {
    constructor(struct) {
        super(struct)
        this.file                   = struct.file;
        this.geometry               = struct.geometry;
        this.tokenChangeUnsubscribe = null;
        this.tokenChangeHandler = this._updateTokenParameter.bind(this);
    }

    addOnMap(map) {
        this._bindTokenParameter()
        super.addOnMap(map)
        if (this.geometry == null) {
            this.elog("ERROR", `Can't add raster layer ${this.id} to the map, geometry struct isn't defined`)
            return
        }

        if (this.layer == null) {
            const layerOptions = {
                layers: this.workspace.id + ':' + this.id,
                format: this.geometry.tileFormat,
                maxZoom: this.geometry.maxZoom,
                minZoom: this.geometry.minZoom,
                transparent: true,
                zIndex: 10,
                bounds: this.bounds,
                className: 'areaTileLayer',
                tiled: true, //it needs to internal geoserver webcache works
            }
            const token = shortLivedTokenManager.getToken()
            if (token != null) {
                layerOptions[RESOURCE_AUTH_TOKEN_PARAMETER] = token
            }
            this.layer = L.tileLayer.wms(this._joinServerUrl("gwc/service/wms"), layerOptions)
            /*
            // here we tried to catch tile load errors due to geoserver wrong configuration or access problems
            // sometimes geoserver tile cache falls with NPE and return xml instead tile img
            // here we try to reload image with 3 attempts
             */
            this.layer.on("tileerror", function (ev) {
                let src = ev.tile.src

                if (ev.tile._retryAttempt === undefined)
                    ev.tile._retryAttempt = 0;
                ev.tile._retryAttempt++;

                if (ev.tile._retryAttempt > 3) {
                    this.elog("WARN", `Can't load tile after 3 attempts: ${ev.tile.src}`);
                    return;
                } else {
                    this.elog("WARN", `Can't load tile (attempt ${ev.tile._retryAttempt}): ${src}`);
                }
                //retry the load
                ev.tile.src = src;
            }.bind(this))

        }

        if (this.visible)
            this._show()
    }

    /**
     * Removes the raster layer and releases its token-change subscription.
     * @returns {void}
     */
    removeFromMap() {
        this._unbindTokenParameter()
        super.removeFromMap()
    }

    /**
     * Synchronizes the WMS token parameter and subscribes to later token changes.
     * Repeated calls preserve the existing subscription.
     * @returns {void}
     * @private
     */
    _bindTokenParameter() {
        this._updateTokenParameter()
        if (this.tokenChangeUnsubscribe == null) {
            this.tokenChangeUnsubscribe = shortLivedTokenManager.onChange(this.tokenChangeHandler)
        }
    }

    /**
     * Releases the token-change subscription from the raster layer.
     * @returns {void}
     * @private
     */
    _unbindTokenParameter() {
        if (this.tokenChangeUnsubscribe != null) {
            this.tokenChangeUnsubscribe()
            this.tokenChangeUnsubscribe = null
        }
    }

    /**
     * Updates the reusable WMS parameters without redrawing visible tiles.
     * @returns {void}
     * @private
     */
    _updateTokenParameter() {
        if (this.layer == null) {
            return
        }

        const token = shortLivedTokenManager.getToken()
        if (token == null) {
            delete this.layer.wmsParams[RESOURCE_AUTH_TOKEN_PARAMETER]
            return
        }
        this.layer.setParams({[RESOURCE_AUTH_TOKEN_PARAMETER]: token}, true)
    }
}
